export default "__VITE_ASSET__zGctjx5o__"